import { ReactNode } from 'react';

import { clsx } from '@freelancelabs/utils';

export interface CardProps {
    children: ReactNode;
    /** Rendered as the card heading. Omit it for a card that carries no title. */
    title?: string;
    /** A pictogram set before the title, in the brand colour. Decorative, so it is hidden from assistive technology. */
    icon?: ReactNode;
    /** Actions aligned opposite the title: an edit button, a link. */
    actions?: ReactNode;
    className?: string;
}

/**
 * Section card of the portal. Inside a `Fiche` it takes the detail look: warm grey
 * border and wider radius: without anything to declare here: the sheet is the one
 * that carries the context.
 */
const Card = ({ children, title, icon, actions, className }: CardProps) => (
    <section className={clsx('fl-card', className)}>
        {(title || actions) && (
            <div className="fl-card__head">
                {title && (
                    <span className="fl-card__heading">
                        {icon && (
                            <span className="fl-card__icon" aria-hidden="true">
                                {icon}
                            </span>
                        )}
                        <h2 className="fl-card__title">{title}</h2>
                    </span>
                )}
                {actions}
            </div>
        )}
        {children}
    </section>
);

export default Card;
